import { render, staticRenderFns } from "./PriceWatch.vue?vue&type=template&id=5430b10f&scoped=true"
import script from "./PriceWatch.vue?vue&type=script&lang=js"
export * from "./PriceWatch.vue?vue&type=script&lang=js"
import style0 from "./PriceWatch.vue?vue&type=style&index=0&id=5430b10f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5430b10f",
  null
  
)

export default component.exports
import QBreadcrumbs from 'quasar/src/components/breadcrumbs/QBreadcrumbs.js';
import QBreadcrumbsEl from 'quasar/src/components/breadcrumbs/QBreadcrumbsEl.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QRouteTab from 'quasar/src/components/tabs/QRouteTab.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBreadcrumbs,QBreadcrumbsEl,QCardSection,QCard,QPageContainer,QLayout,QTabs,QRouteTab});
